<template>
  <div class="bhbox">
    <div class="onebj">
      <div class="wd12 tpshow">
        <div class="tppicture">
          <div class="tpstep">
            <img src="@/assets/images/tjbh/a1.png" class="tpicon" alt />
            <p class="tptext">登录</p>
          </div>
          <img src="@/assets/images/tjbh/huaban.png" class="tpcircle" alt />
           <!-- <div class="tpstep">
            <img src="@/assets/images/tjbh/a1.png" class="tpicon" alt />
            <p class="tptext">登录</p>
          </div> 
           <img src="@/assets/images/tjbh/huaban.png" class="tpcircle" alt />-->
          <div class="tpstep">
            <img src="@/assets/images/tjbh/a2.png" class="tpicon" alt />
            <p class="tptext">抽签</p>
          </div>
          <img src="@/assets/images/tjbh/huaban.png" class="tpcircle" alt />
          <div class="tpstep">
            <img src="@/assets/images/tjbh/a3.png" class="tpicon" alt />
            <p class="tptext">提交作品</p>
          </div>
          <img src="@/assets/images/tjbh/huaban.png" class="tpcircle" alt />
          <div class="tpstep">
            <img src="@/assets/images/tjbh/a4.png" class="tpicon" alt />
            <p class="tptext">专家评审</p>
          </div>
          <img src="@/assets/images/tjbh/huaban.png" class="tpcircle" alt />
          <div class="tpstep">
            <img src="@/assets/images/tjbh/a5.png" class="tpicon" alt />
            <p class="tptext">评审确认</p>
          </div>
          <img src="@/assets/images/tjbh/huaban.png" class="tpcircle" alt />
          <div class="tpstep">
            <img src="@/assets/images/tjbh/a6.png" class="tpicon" alt />
            <p class="tptext">作品展示</p>
          </div>
        </div>
        <div class="tpdashed"></div>
      </div>
      <div class="wd12 newsshow">
        <div class="newsleft"  @click="goDetail(noticeList[0])">
          <img class="newsimg" :src="baseURL+'/'+imgurl" alt />
        </div>
        <div class="newsright">
          <div class="newsline">
            <span class="newstitle">
              <img src="@/assets/images/tjbh/lb.png" class="newsicon" alt />
              通知公告
            </span>
            <span class="newstips" @click="gomore">查看更多>></span>
          </div>
          <div class="newslist">
            <div
              class="newsitem"
              v-for="(item, index) in noticeList"
              :key="index"
              @click="goDetail(item)"
            >
              <span class="newsimgx"></span>
              <p class="newsheader" :title="item.titile">{{item.titile}}</p>
              <p class="newsdate">{{getTime(item.createTime)}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="showimg">
        <img src="@/assets/images/bh/leftzp.png" class="leftimg" alt />
        <img src="@/assets/images/bh/zpzs.png" class="textimg" alt />
        <img src="@/assets/images/bh/rightzp.png" class="rightimg" alt />
      </div> -->
    </div>
    <div class="twobg">
      <div class="wd12">
        <!-- 高职组 -->
        <div class="twoblock">
          <div class="twotitle" style="margin-top: 60px;">
            <img src="@/assets/images/tjbh/bt.png" class="ttbg" alt />
            <span class="tttext">高职组作品</span>
          </div>
          <div class="twogrid" v-if="list1.length>0">
            <div class="zpcard" v-for="(item,index) in list1" :key="'gz-'+index" @click="previewDetail(item)" style="cursor:pointer">
              <div class="zpcover">
                <img :src="getImg(item.name)" @error="handleError" class="zpimg" alt="">
              </div>
              <div class="zpconbox">
                <p class="zptitle">{{item.zpname}}</p>
                <p class="zptext zptext-group"> <img src="@/assets/images/tjbh/z2.png" class="zpicons" alt />学校名称：{{item.realname}}</p>
                <p class="zptext zptext-group"> <img src="@/assets/images/tjbh/z1.png" class="zpicons" alt />作品负责人：{{item.principals}}</p>
                <p class="zptext zptext-group">
                  <img src="@/assets/images/tjbh/z3.png" class="zpicons" alt />
                  组别：<span>{{item.levelType=='1'?'中职组':item.levelType=='2'?'高职组':''}}</span>
                </p>
              </div>
            </div>
          </div>
          <div v-else>
            <img src="@/assets/images/bh/empty.png" class="emptyimg" alt />
          </div>
        </div>

        <!-- 中职组 -->
        <div class="twoblock">
          <div class="twotitle" >
            <img src="@/assets/images/tjbh/bt.png" class="ttbg" alt />
            <span class="tttext">中职组作品</span>
          </div>
          <div class="twogrid" v-if="list2.length>0">
            <div class="zpcard" v-for="(item,index) in list2" :key="'zz-'+index" @click="previewDetail(item)" style="cursor:pointer">
              <div class="zpcover">
                <img :src="getImg(item.name)" @error="handleError" class="zpimg" alt="">
              </div>
              <div class="zpconbox">
                <p class="zptitle">{{item.zpname}}</p>
                <p class="zptext zptext-group"> <img src="@/assets/images/tjbh/z2.png" class="zpicons" alt />学校名称：{{item.realname}}</p>
                <p class="zptext zptext-group"> <img src="@/assets/images/tjbh/z1.png" class="zpicons" alt />作品负责人：{{item.principals}}</p>
                <p class="zptext zptext-group">
                  <img src="@/assets/images/tjbh/z3.png" class="zpicons" alt />
                  组别：<span>{{item.levelType=='1'?'中职组':item.levelType=='2'?'高职组':''}}</span>
                </p>
              </div>
            </div>
          </div>
          <div v-else>
            <img src="@/assets/images/bh/empty.png" class="emptyimg" alt />
          </div>
        </div>
      </div>
    </div>
    <div class="preview-pop-box" v-if="showPreviewPop">
      <div :class="fullscreen ? 'preview-box-fullscreen' : 'preview-box'">
        <preview
          type="education"
          routeName="alApply"
          :video-only="true"
          @goNewPage="goNewPage"
          @closePreview="showPreviewPop = false"
          :preViewData="preViewData"
        ></preview>
      </div>
    </div>
  </div>
</template>
<script>
import { getNoticeList,getAction} from "@/api/index";
import { baseURL } from "@/utils/request.js";
import Preview from "@/components/common/preview.vue";
export default {
  components: { Preview },
  data() {
    return {
      noticeList: [],
      list1:[],
      list2:[],
      baseURL,
      imgurl:'',
      emptyIMG:require('@/assets/images/empty.png'),
      preViewData: {},
      showPreviewPop: false,
      fullscreen: false
    };
  },
  mounted() {
    this.getsj(1, 'list1');
    this.getsj(0, 'list2');
    this.getlist();
  },
  methods: {
     handleError(event){
            return event.target.src=this.emptyIMG;
    },
    getImg(img){
        if(img){
          return this.baseURL+img;
        }else{
          return '';
        }
    },
    // 组别名称(可按需改)
    getGroupName(index){
      const names = ['专业技能课程一组', '专业技能课程二组', '专业技能课程三组'];
      return names[index % names.length];
    },
    gomore(){
       this.$router.push({path:'/notice/list'});
    },
    getTime(time) {
      if (time) {
        const date = new Date(time);
        // 格式化为 YYYY-MM-DD
        const formattedDate = date.toISOString().split("T")[0];
        return formattedDate;
      } else {
        return "";
      }
    },
    gotab(num1) {
      // 保留兼容: 不再切换 tab,改为同时拉取两个 list
      if(num1=='0'){
        this.getsj(1, 'list1');
      }else{
        this.getsj(0, 'list2');
      }
    },
    getsj(num1, key){
      let params = {
      }
      getAction('/lx/lxApply/getScoredWorks?levelType='+(Number(num1)+1),params).then(res => {
        console.log(res);
        if (res.code == "200") {
           this[key]=(res.result||[]).slice(0,4);
        }else{
          this.$message.error(res.message);
          this[key]=[];
        }
      });
    },
    getlist() {
      let params = {
        pageNo: 1,
        pageSize: 10,
        msgCategory: "1"
      };
      getNoticeList(params).then(res => {
        //         console.log(res);
        if (res.code == "0") {
          if (res.result.total > 7) {
            this.noticeList = res.result.records.splice(0, 7);
          } else {
            this.noticeList = res.result.records;
          }
          if(res.result.total > 0){
            this.imgurl=this.noticeList[0].priority;
          }
          
        }
      });
    },
    goDetail(item) {
        this.$router.push({
        name: "noticeDetail",
        query:{
        	id:item.id,
        	type:1,
        }
      });
    },
    previewDetail(item) {
      this.preViewData = item;
      this.showPreviewPop = true;
    },
    goNewPage(flag) {
      this.fullscreen = flag;
    },
  }
};
</script>
<style lang="scss" scoped>
.wd12 {
  width: 1250px;
  height: auto;
  margin: 0px auto;
}
.flex {
  display: flex;
}
.space-ar {
  justify-content: space-between;
}
.bhbox {
  background-color: transparent;
  min-height: 100vh;
  margin-top:-136px;
  .onebj {
    width: 100%;
    // min-height: 740px;
    // background: url("~@/assets/images/bh/onebg.png") no-repeat;
    // background-size: 100% 100%;
    .tpshow {
      padding: 0px 0px 0px;
      margin: 0px auto;
      height: auto;
    }
    .tppicture {
      width: 100%;
      height: 163px;
      background: #FFF9F5;
      box-shadow: 0px 0px 13px 0px rgba(127, 26, 20, 0.35);
      border-radius: 12px;
      display: flex;
      justify-content: space-between;
      // align-items: center;
      padding: 0px 30px;
      box-sizing: border-box;
    }
    .tpstep {
      flex: 0 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .tpicon {
      width: 58px;
      height: 58px;
      object-fit: contain;
      margin-bottom: 10px;
    }
    .tptext {
      line-height: 30px;
      color: #000000;
      font-size: 18px;
      text-align: center;
      margin: 0px;
    }
    .tpcircle {
      width: 47px;
      height: 28px;
      margin-top:48px;
    }
    .tpdashed {
      width: 100%;
      margin-top: 30px;
      // border-top: 1px dashed #b9b9b9;
    }
    .newsshow {
      // width:100%;
      height: 420px;
      display: flex;
      justify-content: flex-start;
      margin-bottom: 40px;
      .newsleft {
        width: 680px;
        height: 420px;
        margin-right: 20px;
        cursor:pointer;
        border-radius:5px;
        overflow: hidden;
        .newsimg {
          width: 100%;
          height: auto;
          min-height: 100%;
          max-height: 200%;
          transition: transform 0.8s ease; /* 添加过渡效果 */
        }
      }
      .newsleft:hover{
        .newsimg {
          transform: scale(1.1);
        }
      }
      .newsright {
        width: 550px;
        height: 420px;
        overflow: hidden;
        .newsline {
          height: 50px;
          border-bottom: 1px solid #DE764D;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
          .newstitle {
            font-weight: bold;
            color: #9A0B00;
            font-size: 26px;
            border-bottom: 4px solid #9A0B00;
            line-height: 48px;
            display: flex;
            align-items: center;
            .newsicon {
              width: 29px;
              height: 29px;
              margin-right: 5px;
              object-fit: contain;
            }
          }
          .newstips {
            font-size: 14px;
            color: #474747;
            cursor: pointer;
          }
          .newstips:hover {
            color: #9A0B00;
          }
        }
        .newslist {
          height: 350px;
          .newsitem {
            height: 50px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;
            .newsimgx {
              width: 7px;
              height: 7px;
              background: #FF6600;
              border-radius: 50%;
              margin-right: 8px;
              display: inline-block;
              flex-shrink: 0;
            }
            .newsheader {
              width: calc(100% - 102px);
              color: #1e1e1e;
              font-size: 16px;
              // display: -webkit-box;
              // -webkit-box-orient: vertical;
              // -webkit-line-clamp: 1; /* 限制行数 */
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin: 0px;
            }
            .newsdate {
              color: #838383;
              font-size: 14px;
              margin: 0px;
            }
          }
          .newsitem:hover {
            .newsheader {
              color: #9A0B00;
            }
          }
        }
      }
    }
    .showimg {
      width: 1100px;
      margin: 0px auto 20px;
      height: 50px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .leftimg,
      .rightimg {
        width: 488px;
        height: auto;
        margin: 0px 20px;
      }
      .textimg {
        width: 143px;
        height: auto;
      }
    }
  }
  .twobg {
    width: 100%;
    background: url("~@/assets/images/tjbh/bjt.png") no-repeat;
    background-size: 100% 100%;
    padding: 40px 0px 50px;
    box-sizing: border-box;
    .twoblock {
      margin-bottom: 30px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
    .twotitle {
      position: relative;
      width: 100%;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 25px;
      margin-top:30px;
      .ttbg {
        width: 1200px;
        height: 30px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
      }
      .tttext {
        position: relative;
        z-index: 2;
        font-size: 24px;
        font-weight: bold;
        color: #ffffff;
        letter-spacing: 4px;
      }
    }
    .twogrid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 20px;
    }
    .zpcard {
      width: 100%;
      background-color: #ffffff;
      border: 1px solid #d4ecfe;
      border-radius: 5px;
      overflow: hidden;
      .zpcover {
        width: 100%;
        height: 180px;
        overflow: hidden;
        
        .zpimg {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.8s ease; /* 添加过渡效果 */
        }
      }
      .zpcover:hover{
        .zpimg {
          transform: scale(1.1);
        }
      }
      .zpconbox {
        padding: 12px 14px;
        .zptitle {
          font-size: 18px;
          color: #242424;
          font-weight: bold;
          line-height: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
          height: 30px;
          margin: 0px 0 6px;
        }
        .zptext {
          color: #4a4a4a;
          line-height: 22px;
          height: 22px;
          font-size: 13px;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin: 0px;
          display: flex;
          align-items: center;
        }
        .zpicons {
          width: 16px;
          height: 16px;
          margin-right: 6px;
          object-fit: contain;
          flex-shrink: 0;
        }
      }
    }
  }
  .emptyimg {
    margin: 20px auto 0px;
    display: block;
  }
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
</style>